import * as React from 'react';
import { styled, SxProps, Theme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

//Personalised style.
const BootstrapDialog = styled(Dialog)(({ theme }) => ({  
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface CustomizedDialogProps {
  onCancel: () => void;
  open: boolean;
  children?: React.ReactNode;
  title?:string;
  titleSx?: SxProps<Theme>;
  dialogWidth?: string;
  dialogMaxWidth?: string;
}

const CustomizedDialog = ({
  onCancel,
  open,
  children,  
  title,
  titleSx, //styles for title
  dialogWidth, //width of dialog container
  dialogMaxWidth, //max width of dialog, by default 600px
  ...props
}: CustomizedDialogProps) => {
  return (
    <BootstrapDialog
      onClose={onCancel}
      aria-labelledby="customized-dialog-title"
      open={open}
      slotProps={{
        paper: {
          sx: {
            width: dialogWidth ?? '100%',
            maxWidth: dialogMaxWidth ?? '600px',
          }
        }        
      }}
      {...props}
    >
      <DialogTitle sx={{ m: 0, p: 2, ...titleSx }} id="customized-dialog-title">        
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
    </BootstrapDialog>
  );
};

export default CustomizedDialog;
